import React, { memo } from 'react';
import {
  Badge,
  IconButton,
  Tooltip,
  Icon,
  MRT_ShowHideColumnsButton,
  MRT_ToggleDensePaddingButton
} from 'investira.react.components';
import { useMRTFiltersContext } from '../../../contexts/MRTFiltersContext';

/**
 * Renderiza o componente MRTToolbarActions.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {*} props.table - Instância da tabela usada pelas ações da toolbar.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
const MRTToolbarActions = memo(({ table }) => {
  const filtersContext = useMRTFiltersContext();
  const canOpenFilters = Boolean(filtersContext?.isReady);
  const activeFilterCount = filtersContext?.activeFilterCount || 0;

  return (
    <>
      {canOpenFilters ? (
        <Tooltip title="Filtros">
          <Badge
            badgeContent={activeFilterCount}
            color="warning"
            overlap="circular"
            invisible={activeFilterCount === 0}
            max={99}>
            <IconButton onClick={filtersContext.openDrawer}>
              <Icon iconName="filter" />
            </IconButton>
          </Badge>
        </Tooltip>
      ) : null}
      <MRT_ShowHideColumnsButton table={table} />
      <MRT_ToggleDensePaddingButton table={table} />
    </>
  );
});

export default MRTToolbarActions;
